import { useEffect } from "react";

import displayToast from "@common/components/Toast/displayToast";
import { ServerToClientEvents, SocketEvents } from "@common/models/webSocketEvents";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { Socket } from "socket.io-client";

interface Params {
  socket?: Socket<ServerToClientEvents, never>;
  refetchItems?: () => void;
}

export default function useReleasesSocketConsumer({ socket, refetchItems }: Params) {
  const { selectedWorkspace } = useAppSelectionContext();

  useEffect(() => {
    if (!selectedWorkspace || !socket) return;

    const handleReleaseSummaryGenerated = async () => {
      refetchItems?.();

      displayToast({
        title: "Finished generating.",
        content: `Release summary generated successfully.`,
      });
    };

    socket.on(SocketEvents.RELEASE_SUMMARY_UPDATED, handleReleaseSummaryGenerated);
    return () => {
      socket.off(SocketEvents.RELEASE_SUMMARY_UPDATED, handleReleaseSummaryGenerated);
    };
  }, [selectedWorkspace, socket, refetchItems]);
}
